import React from 'react';

import SecaoImprensa from '@alweb-merkator/shared/pages/PaginaInicial/SecaoImprensaMerkator';
import SecaoEMerkator from '@alweb-merkator/shared/pages/PaginaInicial/SecaoEMerkator';

import SecaoBanner from './SecaoBanner';
import SecaoQuemSomos from './SecaoQuemSomos';
import SecaoProdutos from './SecaoProdutos';
import SecaoContato from './SecaoContato';
import AlertModal from '@alweb-merkator/shared/components/AlertModal';

const PaginaInicial = () => (
  <>
    <SecaoBanner />
    <SecaoQuemSomos />
    <SecaoProdutos />
    <SecaoEMerkator />
    <SecaoImprensa />
    <SecaoContato />
    {
      <AlertModal
        imageDescription="Assim como todo ano vai ter SICC!"
        urlImage="https://www.sicc.com.br/"
        urlTitle="As feiras da Merkator têm datas marcadas"
        imageModal="https://paineldoexpositor.com.br/uploads/configuration/config_69e1fcb46de0f8_13044712.jpg"
        showModal={false}
      />
    }
  </>
);

export default PaginaInicial;
